import { MijnRoute } from '../../mijn-navigatie.model';

export const PAYMENT_BATCHES_BATCH_BESTAND_DETAILS: MijnRoute = {
    path: 'bestand-details',
    navigationEvent: 'toBetaalbatchesBatchbestanddetails',
    regex: /^\/betaalbatches\/bestand-details$/,
    webcomponent: 'mijn-betalen-betaalbatches-webcomponent',
    internalPath: '/bestand-details'
};
